import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import ChatWidget from "./components/ChatWidget";
import InstallPrompt from "./components/InstallPrompt";
import PromoBanner from "./components/PromoBanner";
import WelcomeModal from "./components/WelcomeModal";
import HomePage from "./pages/HomePage";
import ProductsPage from "./pages/ProductsPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import CategoryLandingPage from "./pages/CategoryLandingPage";
import CategoriesIndexPage from "./pages/CategoriesIndexPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import CheckoutSuccessPage from "./pages/CheckoutSuccessPage";
import VIPPage from "./pages/VIPPage";
import VIPSuccessPage from "./pages/VIPSuccessPage";
import UniversityPage from "./pages/UniversityPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AuthCallbackPage from "./pages/AuthCallbackPage";
import OrdersPage from "./pages/OrdersPage";
import OrderTrackingPage from "./pages/OrderTrackingPage";
import AdminPage from "./pages/AdminPage";
import AffiliatesPage from "./pages/AffiliatesPage";
import PoliciesPage from "./pages/PoliciesPage";
import ContactPage from "./pages/ContactPage";
import ChatPage from "./pages/ChatPage";
import ReferralsPage from "./pages/ReferralsPage";
import WholesalePage from "./pages/WholesalePage";
import WishlistPage from "./pages/WishlistPage";
import AddressBookPage from "./pages/AddressBookPage";
import SupportTicketsPage from "./pages/SupportTicketsPage";
import { WishlistProvider } from "./context/WishlistContext";

function AppContent() {
  const location = useLocation();

  if (location.hash?.includes('session_id=')) {
    return <AuthCallbackPage />;
  }

  return (
    <div className="min-h-screen bg-[#050505]">
      <PromoBanner />
      <Navigation />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/products/:id" element={<ProductDetailPage />} />
        <Route path="/categories" element={<CategoriesIndexPage />} />
        <Route path="/category/:slug" element={<CategoryLandingPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
        <Route path="/checkout/cancel" element={<CartPage />} />
        <Route path="/vip" element={<VIPPage />} />
        <Route path="/vip/success" element={<VIPSuccessPage />} />
        <Route path="/university" element={<UniversityPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/orders/:orderId" element={<OrderTrackingPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/affiliates" element={<AffiliatesPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/policies" element={<PoliciesPage />} />
        <Route path="/chat" element={<ChatPage />} />
        <Route path="/referrals" element={<ReferralsPage />} />
        <Route path="/wholesale" element={<WholesalePage />} />
        <Route path="/wishlist" element={<WishlistPage />} />
        <Route path="/addresses" element={<AddressBookPage />} />
        <Route path="/support" element={<SupportTicketsPage />} />
        <Route path="/support/:ticketId" element={<SupportTicketsPage />} />
      </Routes>
      <Footer />
      <ChatWidget />
      <InstallPrompt />
      <WelcomeModal />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#121212',
            border: '1px solid rgba(255,255,255,0.1)',
            color: '#fff',
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <WishlistProvider>
          <CartProvider>
            <AppContent />
          </CartProvider>
        </WishlistProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;

